import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'Terms', to: '/terms-and-conditions' },
  { label: 'Privacy', to: '/privacy' },
  { label: 'FAQs', to: '/faq' }
];

const footerIcons = [
  { alt: 'X', src: 'images/x.svg', href: 'https://x.com/veruFinance' },
  { alt: 'GitHub', src: 'images/github.svg', href: 'https://github.com/venture-23' },
  { alt: 'Discord', src: 'images/discord.svg', href: 'https://discord.com/invite/qByKMbAw' },
  { alt: 'Medium', src: 'images/medium.svg', href: 'https://verufi.medium.com/' }
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-border-default bg-background-page px-4 py-2 text-primary sm:py-4">
      <div className="max-w-8xl mx-auto flex flex-col items-center justify-between gap-4 px-4 sm:flex-row sm:px-8 md:px-12 lg:px-16 xl:px-20">
        {/* Links Section */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-secondary sm:justify-start sm:gap-4 sm:text-sm md:gap-5">
          {footerLinks.map((item) => (
            <Link key={item.label} to={item.to} className="whitespace-nowrap transition hover:text-white">
              {item.label}
            </Link>
          ))}
        </div>

        {/* Social Icons Section */}
        <div className="flex items-center gap-4 sm:gap-5">
          {footerIcons.map((icon) => (
            <a key={icon.alt} href={icon.href} target="_blank" rel="noopener noreferrer" className="opacity-70 transition hover:opacity-100">
              <img src={icon.src} alt={icon.alt} className="h-4 w-4 sm:h-5 sm:w-5" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
